import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./booking.css";

const Booking = () => {
  const location = useLocation();
  const { tourId, tourTitle, pricings, bookingDaysBefore } = location.state || {};

  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneCode: "",
    phoneNumber: "",
      travelDate: "", // ✅ بدلاً من startDate و endDate
    adults: 1,
    children: 0,
    notes: "",
  });

  const [totalPrice, setTotalPrice] = useState(0);
  // تحديد أقل تاريخ ممكن بناءً على عدد الأيام المسموح قبل الحجز
  const today = new Date();
  const minBookingDate = new Date(today);
  minBookingDate.setDate(today.getDate() + (bookingDaysBefore || 0));
  const minDateFormatted = minBookingDate.toISOString().split("T")[0];

  // 🧮 حساب السعر
  const calculatePrice = (adults, children) => {
    const totalPersons = adults + children;
    if (!pricings || pricings.length === 0) return 0;

    const pricing = pricings.find(
      (p) => totalPersons >= p.min_persons && totalPersons <= p.max_persons
    );

    if (pricing) {
      return totalPersons * parseFloat(pricing.price_per_person);
    }
    return 0;
  };

  const handleNextStep = () => {
    const price = calculatePrice(formData.adults, formData.children);
    setTotalPrice(price);
    setStep(2);
  };

  // تحديث بيانات الفورم
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="booking-wrapper">
      {step === 1 ? (
        <section className="booking-form">
          <h2 className="form-title">Booking Information</h2>
          <form className="grid gap-4">
            {/* Name & Email */}
            <div className="grid md:grid-cols-2 gap-4">
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Full Name*"
                required
                className="form-input-booking modern-booking"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email*"
                required
                className="form-input-booking modern-booking"
              />
            </div>

            {/* Phone */}
          <div className="grid md:grid-cols-2 gap-4">
  <select
    name="phoneCode"
    value={formData.phoneCode}
    onChange={handleChange}
    className="form-input-booking modern-booking"
  >
    <option value="">Select Country Code</option>
    <option value="+1">🇺🇸 United States (+1)</option>
    <option value="+7">🇷🇺 Russia (+7)</option>
    <option value="+20">🇪🇬 Egypt (+20)</option>
    <option value="+27">🇿🇦 South Africa (+27)</option>
    <option value="+30">🇬🇷 Greece (+30)</option>
    <option value="+31">🇳🇱 Netherlands (+31)</option>
    <option value="+32">🇧🇪 Belgium (+32)</option>
    <option value="+33">🇫🇷 France (+33)</option>
    <option value="+34">🇪🇸 Spain (+34)</option>
    <option value="+36">🇭🇺 Hungary (+36)</option>
    <option value="+39">🇮🇹 Italy (+39)</option>
    <option value="+40">🇷🇴 Romania (+40)</option>
    <option value="+41">🇨🇭 Switzerland (+41)</option>
    <option value="+43">🇦🇹 Austria (+43)</option>
    <option value="+44">🇬🇧 United Kingdom (+44)</option>
    <option value="+45">🇩🇰 Denmark (+45)</option>
    <option value="+46">🇸🇪 Sweden (+46)</option>
    <option value="+47">🇳🇴 Norway (+47)</option>
    <option value="+48">🇵🇱 Poland (+48)</option>
    <option value="+49">🇩🇪 Germany (+49)</option>
    <option value="+51">🇵🇪 Peru (+51)</option>
    <option value="+52">🇲🇽 Mexico (+52)</option>
    <option value="+53">🇨🇺 Cuba (+53)</option>
    <option value="+54">🇦🇷 Argentina (+54)</option>
    <option value="+55">🇧🇷 Brazil (+55)</option>
    <option value="+56">🇨🇱 Chile (+56)</option>
    <option value="+57">🇨🇴 Colombia (+57)</option>
    <option value="+58">🇻🇪 Venezuela (+58)</option>
    <option value="+60">🇲🇾 Malaysia (+60)</option>
    <option value="+61">🇦🇺 Australia (+61)</option>
    <option value="+62">🇮🇩 Indonesia (+62)</option>
    <option value="+63">🇵🇭 Philippines (+63)</option>
    <option value="+64">🇳🇿 New Zealand (+64)</option>
    <option value="+65">🇸🇬 Singapore (+65)</option>
    <option value="+66">🇹🇭 Thailand (+66)</option>
    <option value="+81">🇯🇵 Japan (+81)</option>
    <option value="+82">🇰🇷 South Korea (+82)</option>
    <option value="+84">🇻🇳 Vietnam (+84)</option>
    <option value="+86">🇨🇳 China (+86)</option>
    <option value="+90">🇹🇷 Turkey (+90)</option>
    <option value="+91">🇮🇳 India (+91)</option>
    <option value="+92">🇵🇰 Pakistan (+92)</option>
    <option value="+93">🇦🇫 Afghanistan (+93)</option>
    <option value="+94">🇱🇰 Sri Lanka (+94)</option>
    <option value="+95">🇲🇲 Myanmar (+95)</option>
    <option value="+98">🇮🇷 Iran (+98)</option>
    <option value="+211">🇸🇸 South Sudan (+211)</option>
    <option value="+212">🇲🇦 Morocco (+212)</option>
    <option value="+213">🇩🇿 Algeria (+213)</option>
    <option value="+216">🇹🇳 Tunisia (+216)</option>
    <option value="+218">🇱🇾 Libya (+218)</option>
    <option value="+220">🇬🇲 Gambia (+220)</option>
    <option value="+221">🇸🇳 Senegal (+221)</option>
    <option value="+222">🇲🇷 Mauritania (+222)</option>
    <option value="+223">🇲🇱 Mali (+223)</option>
    <option value="+224">🇬🇳 Guinea (+224)</option>
    <option value="+225">🇨🇮 Ivory Coast (+225)</option>
    <option value="+226">🇧🇫 Burkina Faso (+226)</option>
    <option value="+227">🇳🇪 Niger (+227)</option>
    <option value="+228">🇹🇬 Togo (+228)</option>
    <option value="+229">🇧🇯 Benin (+229)</option>
    <option value="+230">🇲🇺 Mauritius (+230)</option>
    <option value="+231">🇱🇷 Liberia (+231)</option>
    <option value="+233">🇬🇭 Ghana (+233)</option>
    <option value="+234">🇳🇬 Nigeria (+234)</option>
    <option value="+235">🇹🇩 Chad (+235)</option>
    <option value="+236">🇨🇫 Central African Republic (+236)</option>
    <option value="+237">🇨🇲 Cameroon (+237)</option>
    <option value="+238">🇨🇻 Cape Verde (+238)</option>
    <option value="+239">🇸🇹 São Tomé & Príncipe (+239)</option>
    <option value="+240">🇬🇶 Equatorial Guinea (+240)</option>
    <option value="+241">🇬🇦 Gabon (+241)</option>
    <option value="+242">🇨🇬 Republic of Congo (+242)</option>
    <option value="+243">🇨🇩 DR Congo (+243)</option>
    <option value="+244">🇦🇴 Angola (+244)</option>
    <option value="+249">🇸🇩 Sudan (+249)</option>
    <option value="+250">🇷🇼 Rwanda (+250)</option>
    <option value="+251">🇪🇹 Ethiopia (+251)</option>
    <option value="+254">🇰🇪 Kenya (+254)</option>
    <option value="+255">🇹🇿 Tanzania (+255)</option>
    <option value="+256">🇺🇬 Uganda (+256)</option>
    <option value="+260">🇿🇲 Zambia (+260)</option>
    <option value="+263">🇿🇼 Zimbabwe (+263)</option>
    <option value="+350">🇬🇮 Gibraltar (+350)</option>
    <option value="+351">🇵🇹 Portugal (+351)</option>
    <option value="+352">🇱🇺 Luxembourg (+352)</option>
    <option value="+353">🇮🇪 Ireland (+353)</option>
    <option value="+354">🇮🇸 Iceland (+354)</option>
    <option value="+355">🇦🇱 Albania (+355)</option>
    <option value="+356">🇲🇹 Malta (+356)</option>
    <option value="+357">🇨🇾 Cyprus (+357)</option>
    <option value="+358">🇫🇮 Finland (+358)</option>
    <option value="+359">🇧🇬 Bulgaria (+359)</option>
    <option value="+370">🇱🇹 Lithuania (+370)</option>
    <option value="+371">🇱🇻 Latvia (+371)</option>
    <option value="+372">🇪🇪 Estonia (+372)</option>
    <option value="+373">🇲🇩 Moldova (+373)</option>
    <option value="+374">🇦🇲 Armenia (+374)</option>
    <option value="+375">🇧🇾 Belarus (+375)</option>
    <option value="+376">🇦🇩 Andorra (+376)</option>
    <option value="+377">🇲🇨 Monaco (+377)</option>
    <option value="+380">🇺🇦 Ukraine (+380)</option>
    <option value="+381">🇷🇸 Serbia (+381)</option>
    <option value="+385">🇭🇷 Croatia (+385)</option>
    <option value="+386">🇸🇮 Slovenia (+386)</option>
    <option value="+387">🇧🇦 Bosnia & Herzegovina (+387)</option>
    <option value="+389">🇲🇰 North Macedonia (+389)</option>
    <option value="+420">🇨🇿 Czech Republic (+420)</option>
    <option value="+421">🇸🇰 Slovakia (+421)</option>
    <option value="+852">🇭🇰 Hong Kong (+852)</option>
    <option value="+853">🇲🇴 Macao (+853)</option>
    <option value="+855">🇰🇭 Cambodia (+855)</option>
    <option value="+856">🇱🇦 Laos (+856)</option>
    <option value="+880">🇧🇩 Bangladesh (+880)</option>
    <option value="+971">🇦🇪 United Arab Emirates (+971)</option>
    <option value="+972">🇮🇱 Israel (+972)</option>
    <option value="+973">🇧🇭 Bahrain (+973)</option>
    <option value="+974">🇶🇦 Qatar (+974)</option>
    <option value="+975">🇧🇹 Bhutan (+975)</option>
    <option value="+976">🇲🇳 Mongolia (+976)</option>
    <option value="+977">🇳🇵 Nepal (+977)</option>
    <option value="+994">🇦🇿 Azerbaijan (+994)</option>
    <option value="+995">🇬🇪 Georgia (+995)</option>
    <option value="+996">🇰🇬 Kyrgyzstan (+996)</option>
    <option value="+998">🇺🇿 Uzbekistan (+998)</option>
  </select>

  <input
    type="text"
    name="phoneNumber"
    value={formData.phoneNumber}
    onChange={handleChange}
    placeholder="Phone Number*"
    className="form-input-booking modern-booking"
  />
</div>


            {/* Dates */}
           {/* Travel Date */}
<div>
  <input
  type="date"
  name="travelDate"
  value={formData.travelDate}
  onChange={handleChange}
  className="form-input-booking modern-booking"
  required
  min={minDateFormatted} // ✅ يمنع اختيار تاريخ قبل الحد الأدنى
/>
</div>


            {/* Guests */}
           {/* Guests with counters */}
<div className="grid md:grid-cols-2 gap-4">
  {/* Adults counter */}
  <div className="counter-box">
    <span>Adults</span>
    <div className="counter-controls">
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({
            ...prev,
            adults: prev.adults > 1 ? prev.adults - 1 : 1,
          }))
        }
      >
        -
      </button>
      <span>{formData.adults}</span>
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({ ...prev, adults: prev.adults + 1 }))
        }
      >
        +
      </button>
    </div>
  </div>

  {/* Children counter */}
  <div className="counter-box">
    <span>Children</span>
    <div className="counter-controls">
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({
            ...prev,
            children: prev.children > 0 ? prev.children - 1 : 0,
          }))
        }
      >
        -
      </button>
      <span>{formData.children}</span>
      <button
        type="button"
        onClick={() =>
          setFormData((prev) => ({ ...prev, children: prev.children + 1 }))
        }
      >
        +
      </button>
    </div>
  </div>
</div>


            {/* Note */}
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Special Requests"
              className="form-input-text-area-booking modern w-full"
            ></textarea>

           

            <button
              type="button"
              onClick={handleNextStep}
              className="submit-btn"
            >
              Continue to Payment
            </button>
          </form>
        </section>
      ) : (
        <div className="payment-card">
          <h2 className="form-title">Secure Payment</h2>
          <p className="tour-info">Tour: {tourTitle}</p>
          <p className="total-price">Total: ${totalPrice}</p>
              <form>
            <div className="form-group">
              <label>Cardholder Name</label>
              <input type="text" placeholder="John Doe" />
            </div>
            <div className="form-group">
              <label>Card Number</label>
              <input type="text" placeholder="1234 5678 9012 3456" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Expiry Date</label>
                <input type="text" placeholder="MM/YY" />
              </div>
              <div className="form-group">
                <label>CVV</label>
                <input type="password" placeholder="***" />
              </div>
            </div>
            <div className="text-center">
              <button className="submit-btn">Pay Now</button>
            </div>
          </form>

          <button className="back-btn" onClick={() => setStep(1)}>
            ← Back to Booking
          </button>
        </div>
      )}
    </div>
  );
};

export default Booking;
